import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Subject, catchError, map } from 'rxjs';
import { Router } from '@angular/router';
import { ApiService } from './api.service';


const apiUrl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  elu: any;
  eluChanges: Subject<any> = new Subject<any>();

  constructor(private http: HttpClient, private router: Router, private apiService: ApiService) { }

  login(login: string, password: string) {
    let formData = new FormData();
    formData.append('login', login);
    formData.append('password', password);

    return this.http.post(`${apiUrl}/login/elu`, formData).pipe(
      map((res: any) => {
        this.elu = res.elu;
        this.eluChanges.next(res.elu);
        return res;
      }),
      catchError((error: any) => {
        throw new Error(error.message);
      })
    );
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('elu');
    localStorage.removeItem('callback_token');
    this.elu = null;
    this.eluChanges.next(null);
    this.router.navigate(['/public/login']);
  }
}
